// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const ErrorMessage = styled.div`
  font-size: 11pt;
  text-align: center;
  color: #d85350;
  padding-bottom: 1rem;
`;

const StyledP = styled.p`
  margin-bottom: 0 !important;
`;

const ErrorMessageComponent = ({ message }) => {
  if (!message) return null; // Sicherstellen, dass message existiert

  return (
    <ErrorMessage>
      {message.split(/\r?\n/).map((line, index) => (
        <StyledP key={index}>{line}</StyledP>
      ))}
    </ErrorMessage>
  );
};

export default ErrorMessageComponent;
